import { render, staticRenderFns } from "./ZZPR-Project.vue?vue&type=template&id=2163e446"
import script from "./ZZPR-Project.vue?vue&type=script&lang=js"
export * from "./ZZPR-Project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports